<script setup lang="ts">
import defaultUserImage from "@/assets/images/profile/user-1.jpg";
import { UserRoleAvatar } from "@/utils/asyncLoading";

import { useStoreUser } from "@/stores/storeUser";
import { isEmptyCheckLocal } from "@/utils/utils";

const storeUser = useStoreUser();
const user = computed(() => storeUser.userData);
const company = computed(() => storeUser.companyData);
const userCompany = computed(() => storeUser.userCompanyData);
const userImage = computed(() => {
  return !isEmptyCheckLocal(storeUser.userData?.imageUrl)
    ? storeUser.userData?.imageUrl
    : defaultUserImage;
});

const { t } = useI18n();
</script>
<template>
  <v-card elevation="10" class="overflow-hidden" max-height="170">
    <v-card-item class="pb-0">
      <v-row>
        <v-col cols="12">
          <div class="d-flex gap-3 align-center">
            <v-avatar size="35">
              <img :src="userImage" width="35" />
            </v-avatar>
            <div class="text-h4">
              {{ t("dashboard.welcomeTitle", { name: user.displayName }) }}
            </div>
          </div>

          <div class="text-h6 mt-2">
            <UserRoleAvatar
              :role="userCompany.role"
              :avatarSize="30"
              :userInternalRole="user.internalRole"
            />
          </div>
          <div class="text-h6 mt-2">
            {{ t("company.label") + ": " + company?.companyName }}
          </div>

          <div class="text-h6 my-2">
            {{
              t("company.authProfile.labelExtended") +
              ": " +
              t("company.authProfile." + company?.authProfileId)
            }}
          </div>
        </v-col>
      </v-row>
    </v-card-item>
  </v-card>
</template>
